import { atom } from "nanostores";

export enum NetworkStatus {
  OFFLINE = "offline",
  CONNECTED = "connected",
  DISCONNECTED = "disconnected",
  GRACEFUL_KICK = "graceful_kick",
}

export enum NetworkGameCycle {
  IDLE = "idle",
  PLAYING = "playing",
}

export const networkStatus = atom(NetworkStatus.OFFLINE);
export const networkGameCycle = atom(NetworkGameCycle.IDLE);
